import { Injectable } from '@angular/core';
import { BuildDateFilter } from '@greco/ngx-filters';

@Injectable({ providedIn: 'any' })
export class CategoryCreatedDateFilter extends BuildDateFilter('CategoryCreatedDateFilter', {
  label: 'Created Date',
  shortLabel: 'Date',
  description: '',
  properties: ['created'],
}) {}
